import axios from "axios";
import router from "../router/index";
import store from "../store/index";
import { Message } from "element-ui";
import "./../styles/icon/iconfont.css";
import { API_BASE_URL } from "../config";
import { getToken, removeToken } from "./auth";
import { getAdminToken, getValidAdminToken, isAdminLoggedIn, clearAdminData, adminLogout } from "./adminAuth";

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000  // 普通请求超时时间15秒
});
//文件上传地址
store.dispatch("uploadimage", "http://localhost:9093/mathub/v8/file/upload");
// 请求超时时间
// 请求头设置
service.defaults.headers.post["Content-Type"] =
  "application/json;charset=UTF-8";

//请求拦截器
service.interceptors.request.use(config => {
  // 优先使用admin token（如果admin已登录）
  if (isAdminLoggedIn()) {
    const adminToken = getValidAdminToken();
    if (adminToken) {
      config.headers["Authorization"] = `Bearer ${adminToken}`;
      // 添加admin标识，让后端知道这是admin请求
      config.headers["X-Admin-Request"] = "true";
    }
  } else {
    // 使用普通用户token
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
  }
  
  // 检查是否是文件上传请求，如果是，设置较长的超时时间
  if (config.headers['Content-Type'] && config.headers['Content-Type'].includes('multipart/form-data')) {
    config.timeout = 300000; // 5分钟
  }
  
  return config;
});
//响应拦截器
service.interceptors.response.use(
  response => {
    const { status } = response;
    if (status === 200) {
      if (response.data.code == -5) {
        // 检查是否是管理员请求
        const isAdminRequest = response.config.headers && response.config.headers['X-Admin-Request'] === 'true';
        
        if (isAdminRequest && isAdminLoggedIn()) {
          // 管理员token失效，清除管理员数据并退出登录
          Message.error({
            message: "管理员登录已过期，请重新登录",
            description: "管理员登录已过期，请重新登录"
          });
          // 清除管理员数据
          clearAdminData();
          // 清除Vuex store中的管理员相关数据
          store.dispatch("resetUserState");
          // 跳转到管理员登录页
          router.push({ name: 'AdminLogin' }).catch(() => {});
        } else {
          // 普通用户token失效
          Message.error({
            message: "登录过期，请重新登录",
            description: "登录过期，请重新登录"
          });
          removeToken();
          location.reload();
        }
      }
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    if (error.response) {
      const isAdminRequest = error.config && error.config.headers && error.config.headers['X-Admin-Request'] === 'true';
      
      switch (error.response.status) {
        // 未登录
        case 401:
          if (isAdminRequest && isAdminLoggedIn()) {
            // 管理员认证失败，清除数据并退出登录
            Message.error("管理员认证失败，请重新登录");
            clearAdminData();
            store.dispatch("resetUserState");
            router.push({ name: 'AdminLogin' }).catch(() => {});
          }
          break;
        // 登录失效
        case 403:
          if (isAdminRequest && isAdminLoggedIn()) {
            // 管理员权限不足或token失效
            Message.error("管理员登录已过期，请重新登录");
            clearAdminData();
            store.dispatch("resetUserState");
            router.push({ name: 'AdminLogin' }).catch(() => {});
          }
          break;
        // Not Found
        case 404:
          break;
        // 服务器错误
        case 500:
          break;
        default:
          break;
      }
      return Promise.reject(error.response);
    } else {
      // Handle network errors
      if (error.message && error.message.includes("timeout")) {
        Message.error({ message: "请求超时，请检查网络连接。" });
      } else {
        Message.error({
          message: "无法连接到服务器。请确认后端服务正在运行。"
        });
      }
    }
    return Promise.reject(error);
  }
);
export default service;
